import { render, staticRenderFns } from "./DemandDetailCard.vue?vue&type=template&id=2615c034&"
import script from "./DemandDetailCard.vue?vue&type=script&lang=js&"
export * from "./DemandDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./DemandDetailCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports